/*
  RT cart behavior layer.
  Keep optional cart drawer behavior customizations here.
*/
(() => {
  const CART_UPDATE_EVENT = 'cart:update';

  // Close the mobile cart drawer before payment apps open their checkout UI.
  // Native modal dialogs render in the browser's top layer and can otherwise
  // cover payment tabs injected by third-party apps.
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const checkoutButton = event.target.closest('#checkout');
      if (!checkoutButton) return;

      checkoutButton.closest('theme-drawer')?.close();
    },
    true
  );

  document.addEventListener(CART_UPDATE_EVENT, (event) => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    const itemCount = Number(event?.detail?.data?.itemCount || 0);
    drawer.toggleAttribute('data-rt-cart-has-items', itemCount > 0);
  });
})();
